import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function queryList(data) {
  return request({
    url: `/admin/mall/goodsCategory/select`,
    method: "POST",
    data,
    // isEncrypt:false,
    // isDecrypt:false
  });
}

/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addList(data) {
  return request({
    url: `/admin/mall/goodsCategory/add`,
    method: "POST",
    data,
  });
}

/**
 * 更改
 * @param {*} data
 * @returns
 */
export function updateList(data) {
  return request({
    url: `/admin/mall/goodsCategory/update`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteList(data) {
  return request({
    url: `/admin/mall/goodsCategory/delete`,
    method: "POST",
    data
  });
}
